import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import praiseImg from '@/images/praise.gif'

import { mobile } from '../../utils/media-query'
import GradientTextButton from '../../shared/gradient-color-text-button'
import TransparentTextButton from '../../shared/transparent-text-button'

const Background = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 434px;
  background: linear-gradient(-135deg, rgb(0, 255, 153) 0%, rgb(153, 51, 255) 100%);
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${mobile.css`
        width: 100%;
        padding: 0 14px;
    box-sizing: border-box;
    `}

  h1 {
    text-align: center;

    ${mobile.css`
            width: 100%;
            margin-bottom: 5px;
            line-height: normal;
        `}
  }

  img {
    width: 120px;
    margin-bottom: 20px;

    ${mobile.css`
            width: 60px;
            margin-top: -5px;
        `}
  }

  p {
    text-align: center;
    margin-bottom: 37px;
    color: white;
    font-size: 20px;
    line-height: 28px;

    ${mobile.css`
            width: 100%;
            margin-bottom: 25px;
        `}
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  & > :first-child {
    margin-right: 20px;
  }

  ${mobile.css`
        width: 100%;
        flex-direction: column;
        align-items: center;
        height: 96px;
        margin-bottom: 0;

        & > :first-child {
            margin-right: 0;
        }
    `}
`

const ExtendedLink = styled(Link)`
  border-bottom: none;
`

const EndBreaker = () => (
  <Background>
    <Container>
      <img alt="" src={praiseImg} />
      <h1>Dive in, we’re here to help along the way</h1>
      <p>Get started building with our SDK and API QuickStart Guides.</p>
      <Buttons>
        <ExtendedLink to={'/docs/sdk'}>
          <GradientTextButton text={'Get Started with the SDK'} />
        </ExtendedLink>
        <ExtendedLink to={'/docs/api'}>
          <TransparentTextButton text={'Get Started with the API'} />
        </ExtendedLink>
      </Buttons>
    </Container>
  </Background>
)

export default EndBreaker
